export default "__VITE_ASSET__bd7b26ed__"